"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

exports.flatten = flatten;
exports.getDetaultPropertiesForInstance = getDetaultPropertiesForInstance;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function flatten(objects) {
  return objects.reduce(function (prev, nextObj) {
    return (0, _assign2.default)(prev, nextObj);
  }, {});
}

function getDetaultPropertiesForInstance(instance) {
  var constructors = [];

  for (var o = (0, _getPrototypeOf2.default)(instance); o != null; o = (0, _getPrototypeOf2.default)(o)) {
    constructors.unshift(o.constructor);
  }

  var defaultPropertiesList = constructors.map(function (o) {
    return o.defaultProperties;
  });
  return flatten(defaultPropertiesList);
}